import type React from "react";
import { type ReactNode, useContext } from "react"
import { Navigate } from "react-router-dom";
import { UserContext } from "../lib/context/UserContext";
import PageLoader from "../components/pageLoader/pageLoader";

interface IRouteGuardProps {
  allowedRoles: string[];
  children: ReactNode;
}

const RouteGuard: React.FC<IRouteGuardProps> = ({ allowedRoles, children }) => {
  const user = useContext(UserContext);

  if (user === null || user.roles === undefined || user.roles.length === 0) {
    return <PageLoader />
  }

  const isRouteValid = () => {
    return (
      Array.isArray(user.roles) &&
      user.roles.some((role) => allowedRoles.includes(role))
    );
  };

  return isRouteValid() ? (
    children
  ) : (
    <Navigate to="/unauthorized" replace />
  );
};

export default RouteGuard;
